import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import SWLogo from "../assests/img/smartworks-logo.svg";
import SearchIcon from "../assests/img/search-icon.svg";
import MenuDots from "../assests/img/menu-dots.svg";
import AddingAttachementIcon from "../assests/img/Adding-Attachment-Icon.svg";
import { handleLogOut } from "../utils/ClearCache";
import SearchCancelIcon from "../assests/img/search-cancel-icon.svg";
import { Button, Modal } from "react-bootstrap";
import AttachementRemoveIcon from "../assests/img/Attachement-close-icon.svg";
import PdfFileIcon from "../assests/img/pdf-file-icon.svg";
import CSVIcon from "../assests/img/csv.svg";
import XLSXIcon from "../assests/img/xlsx.svg";
import PowerPointIcon from "../assests/img/powerpoint.svg";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import VideoIcon from "../assests/img/video.svg";
import DocIcon from "../assests/img/doc.svg";
import ZipIcon from "../assests/img/zip.svg";
import SwSingleSelect from "../components/Common/ReactSelect";
import {
  fetchCategoriesAndSubCategoriesForRaiseticket,
  fetchLocationForRT,
  fetchProjectsForTicketType,
  quickFilter,
  submitRaiseTicket,
} from "../utils/API/TicketAPI";
import debounce from "lodash.debounce";
import axiosInstance from "../utils/axiosInstance";
import axios from "axios";

const Header = (props) => {
  const {
    handleSearchInputChange,
    searchQuery,
    handleClearSearch,
    handleSearchInputKeyDown,
    setCurrentPage,
    setActiveTab,
    setRaiseticketStatud,
    dataRaiseTT,
    activeTab,
    userDetails,
    isTicketUser,
  } = props;

  const storedDecodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const fileInputRef3 = useRef(null);
  const [selectedProjectClient, setSelectedProjectClient] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isFetchingUsers, setIsFetchingUsers] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [isBehalfClient, setIsBehalfClient] = useState(false);
  const [raiseTLocation, setRaiseTLocation] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [filteredSubCategoryOptions, setFilteredSubCategoryOptions] = useState(
    []
  );
  const [orgIdFromProject, setOrgIdFromProject] = useState(null);
  const [ticketTypeRaise, setTicketTypeRaise] = useState("");
  const [selectedRaiseLocation, setSelectedRaiseLocation] = useState("");
  const [raiseTProjects, setRaiseTProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [floorForRT, setFloorForRT] = useState([]);
  const [selectedRaiseFloor, setSelectedRaiseFloor] = useState(null);
  const [uploadedFilesRaise, setUploadedFilesRaise] = useState([]);
  const [errorMessageReopen, setErrorMessageReopen] = useState("");
  const [company, setCompany] = useState([]);
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [selectedCompany, setselectedCompany] = useState([]);
  const [query, setQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRaiseLocationCode, setSelectedRaiseLocationCode] =
    useState("");
  const [floorName, setFloorName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [loading, setLoading] = useState(false);
  const [showBehalfClientSection, setShowBehalfClientSection] = useState(false);
  const [raiseAnotherTicket, setRaiseAnotherTicket] = useState(false);
  const [ticketNumber, setTicketNumber] = useState(null); // New state for dynamic ticket number
  const [previousTicketNumber, setPreviousTicketNumber] = useState(null); // New state for previous ticket number



  const handleOpenModal = () => {
    resetValue();
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setTicketNumber(null); // Reset ticket number when closing modal
    if (isTicketUser) {
      window.location.reload();
    }
  };

  const getLocationForRT = async () => {
    try {
      const response = await fetchLocationForRT();
      if (response.data.statusValue === 200) {
        const locationRaise = response.data.data
          .sort((a, b) => a.locationName.localeCompare(b.locationName))
          .map((locationRaise) => ({
            label: locationRaise.locationName,
            value: locationRaise._id,
            newPropertyId: locationRaise.new_property_id,
            locationCode: locationRaise.locationCode,
          }));
        setRaiseTLocation(locationRaise);
      } else {
        setRaiseTLocation([]);
      }
    } catch (error) {
      console.error("Error fetching company names", error);
    }
  };

  // Add useEffect to handle auto-selection
useEffect(() => {
  if (raiseTLocation?.length === 1 && !selectedRaiseLocation) {
    handleChangeRaiseLocation(raiseTLocation[0]);
  }
}, [raiseTLocation, selectedRaiseLocation]);

  const fetchFloors = async (locationIds) => {
    if (!locationIds) return;
    const idsArray = locationIds;
    try {
      const allFloors = [];
      const responses = await Promise.all(
        idsArray.map(async (id) => {
          try {
            const response = await axiosInstance.get(
              `${process.env.REACT_APP_API_FILE_UPLOAD}core/properties/${id}?includes=floors`
            );
            if (response.data.message === "Property fetched successfully") {
              return response.data.data.floors.map((floor) => ({
                label: floor.name,
                value: floor.id,
              }));
            }
          } catch (error) {
            console.error(`Error fetching floors for locationId ${id}`, error);
            return [];
          }
        })
      );
      responses.forEach((floors) => allFloors.push(...floors));
      const sortedFloors = allFloors.sort((a, b) =>
        a.label.localeCompare(b.label)
      );
      setFloorForRT(sortedFloors);
      // Auto-select if only one floor
      if (sortedFloors?.length === 1) {
        handleChangeRaiseFloor(sortedFloors[0]);
      }
    } catch (error) {
      console.error("Error fetching floors", error);
      setFloorForRT([]);
    }
  };

  const fetchCompany = async (locationId) => {
    if (!locationId) return;
    const id = Array.isArray(locationId) ? locationId[0] : locationId;
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_FILE_UPLOAD}core/organizations/by-property`,
        { ids: [id] }
      );
      if (response.data?.message === "Organizations fetched successfully.") {
        const sortedCompany = response.data.data
          .map((c) => ({
            label: c.name,
            value: c.id,
            companyId: c.old_db_id,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setCompany(sortedCompany);
      } else {
        console.error("Unexpected API response:", response.data);
        setCompany([]);
      }
    } catch (error) {
      console.error("Error fetching company:", error);
      setCompany([]);
    }
  };

  const handleChangeRaiseLocation = async (selected) => {
    const selectedId = selected?.value;
    setSelectedRaiseLocation(selectedId);

    const selectedLocationObj = raiseTLocation?.find(
      (loc) => loc.value === selectedId
    );

    if (!selectedLocationObj) {
      setSelectedRaiseLocationCode("");
      setCompany([]);
      setFloorForRT([]);
      setRaiseTProjects([]);
      setSelectedProject("");
      setSelectedRaiseFloor(null);
      //////////bug
      setselectedCompany(null);
      setSelectedUser(null);
      setQuery("");
      setUsers([]);
      return;
    }

    setSelectedRaiseLocationCode(selectedLocationObj.locationCode);

    // Handle single or multiple newPropertyId(s)
    const propertyIds = Array.isArray(selectedLocationObj.newPropertyId)
      ? selectedLocationObj.newPropertyId
      : [selectedLocationObj.newPropertyId];

    // Reset floor and company related fields/////bug
    setFloorForRT([]);
    setSelectedRaiseFloor(null);
    setCompany([]);
    setselectedCompany(null);
    setSelectedUser(null);
    setQuery("");
    setUsers([]);

    // Fetch company and floors based on ticket type
    if (ticketTypeRaise !== "snag") {
      fetchCompany(propertyIds);
    }

    if (ticketTypeRaise !== "snag" && ticketTypeRaise !== "site-report") {
      fetchFloors(propertyIds);
    }

    // Fetch projects for specific ticket types
    let projectStatus = [];
    if (ticketTypeRaise === "snag") {
      projectStatus = ["Accepting snags"];
    } else if (ticketTypeRaise === "site-report") {
      projectStatus = ["Project created"];
    }

    if (projectStatus.length > 0) {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_FILE_UPLOAD}bms/sls/v1/ticket/projects`,
          {
            locationCode: [selectedLocationObj.locationCode],
            projectStatus,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        const projectOptions = res.data?.data?.map((project) => ({
          label: project.name,
          value: project._id,
          floor: {
            label: project.floor.name,
            value: project.floor.floorId,
          },
          name: project.name,
          _id: project._id,
          client: project.client,
        }));

        setRaiseTProjects(projectOptions);
        setSelectedProject("");
        setFloorForRT([]);
        setSelectedRaiseFloor(null);
      } catch (err) {
        console.error("Error fetching projects:", err);
        setRaiseTProjects([]);
        setSelectedProject("");
        setFloorForRT([]);
        setSelectedRaiseFloor(null);
      }
    } else {
      setRaiseTProjects([]);
      setSelectedProject("");
      setFloorForRT([]);
      setSelectedRaiseFloor(null);
    }
  };

  const handleChangeRaiseFloor = (selected) => {
    const newSelectedFloor = selected?.value;
    setSelectedRaiseFloor(newSelectedFloor);
    const floorSelectionName = floorForRT?.find(
      (floor) => floor.value === newSelectedFloor
    );
    setFloorName(floorSelectionName?.label || "");
  };

  const handleBehalfOfClient = () => {
    setIsBehalfClient(!isBehalfClient);
  };

  const handleTicketTypeRaiseChange = (selected) => {
    const value = selected ? selected.value : "";
    setTicketTypeRaise(value);
    setCategoryOptions([]);
    setSelectedCategories(null);
    setFilteredSubCategoryOptions([]);
    setSelectedSubCategories(null);
    setShowBehalfClientSection(selected?.status === true);
    setRaiseTProjects([]);
    setSelectedProject(null);
    setFloorForRT([]);
    setSelectedRaiseFloor(null);
    // Reset location related fields
    setSelectedRaiseLocation("");
    setSelectedRaiseLocationCode("");
    setCompany([]);
    setselectedCompany(null);
    setSelectedUser(null);
    setQuery("");
    setUsers([]);
  };

  console.log(activeTab, "activeTab");
  const handleChangeProject = async (selected) => {
    const selectedProjectId = selected?.value;
    setSelectedProject(selectedProjectId);
    const selectedProj = raiseTProjects.find(
      (proj) => proj.value === selectedProjectId
    );
    if (selectedProj?.floor) {
      setFloorForRT([selectedProj.floor]);
      setSelectedRaiseFloor(selectedProj.floor.value);
    } else {
      setFloorForRT([]);
      setSelectedRaiseFloor(null);
    }
    const client = selectedProj?.client;
    if (client?.clientId && client?.clientName) {
      const mappedCompany = {
        value: client.clientId,
        label: client.clientName,
        companyId: client.oldDbId,
      };
      setselectedCompany(mappedCompany);
      setCompany([mappedCompany]);
      try {
        const orgRes = await axiosInstance.get(
          `${process.env.REACT_APP_API_FILE_UPLOAD}core/organizations/${client.oldDbId}`
        );
        if (orgRes.data?.message === "Organization fetched successfully.") {
          const actualOrgId = orgRes.data.data.id;
          setOrgIdFromProject(actualOrgId);
          fetchUsers("", actualOrgId);
        } else {
          console.error("Unexpected organization response:", orgRes.data);
        }
      } catch (error) {
        console.error("Error fetching organization by oldDbId:", error);
      }
    } else {
      setselectedCompany(null);
      setCompany([]);
    }
  };

  const fetchCategoriesAndSubCategoriesData = async () => {
    try {
      if (!ticketTypeRaise) return;
      const response = await fetchCategoriesAndSubCategoriesForRaiseticket(
        ticketTypeRaise
      );
      if (response.data.statusValue === 200) {
        const categories = response.data.data.map((item) => ({
          label: item.category,
          value: item.category,
          subCategories: item.subCategories.map((sub) => ({
            label: sub,
            value: sub,
          })),
        }));
        setCategoryOptions(categories);
        // Auto-select if only one category
        if (categories?.length === 1) {
          setSelectedCategories(categories[0]);
        }
      } else {
        setCategoryOptions([]);
        setFilteredSubCategoryOptions([]);
      }
    } catch (error) {
      console.error("Error fetching categories and subcategories", error);
    }
  };

  useEffect(() => {
    fetchCategoriesAndSubCategoriesData();
  }, [ticketTypeRaise]);

  useEffect(() => {
    if (selectedCategories) {
      const subCategories = selectedCategories.subCategories;
      setFilteredSubCategoryOptions(subCategories);
      // Auto-select if only one sub-category
      if (subCategories?.length === 1) {
        setSelectedSubCategories(subCategories[0]);
      } else {
        setSelectedSubCategories(null);
      }
    } else {
      setFilteredSubCategoryOptions([]);
      setSelectedSubCategories(null);
    }
  }, [selectedCategories]);

  useEffect(() => {
    getLocationForRT();
  }, []);

  const getMimeType = (url) => {
    if (url !== undefined) {
      const extension = url.split(".").pop();
      switch (extension) {
        case "pdf":
          return "application/pdf";
        case "docx":
          return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return `image/${extension}`;
        case "ppt":
          return "application/vnd.ms-powerpoint";
        case "mp4":
          return "video/mp4";
        case "MP4":
          return "video/MP4";
        case "mov":
          return "video/mov";
        case "webm":
          return "video/webm";
        case "zip":
          return "application/zip";
        case "csv":
          return "text/csv";
        case "xlsx":
          return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        default:
          return "png";
      }
    }
  };

  const showToast = (message) => {
    toast.error(message);
  };

  const handleFileRaiseChange = (event) => {
    const files = Array.from(event.target.files);
    setUploadedFilesRaise((prevFiles) => {
      const totalFiles = prevFiles.length + files.length;
      if (totalFiles > 10) {
        setErrorMessageReopen("Maximum 10 attachments is allowed");
        showToast("Maximum 10 attachments is allowed");
        return prevFiles;
      }
      let totalSize =
        files.reduce((sum, file) => sum + file.size, 0) +
        prevFiles.reduce((sum, file) => sum + file.size, 0);
      if (totalSize > 100 * 1024 * 1024) {
        setErrorMessageReopen("Maximum size will be 100MB");
        showToast("Maximum size will be 100MB");
        return prevFiles;
      }
      setErrorMessageReopen("");
      return [...prevFiles, ...files];
    });
  };

  useEffect(() => {}, [uploadedFilesRaise]);

  const handleIconClickReopen = () => {
    if (fileInputRef3.current) {
      fileInputRef3.current.click();
    }
  };

  const handleRemoveImage = (index) => {
    const updatedFiles = [...uploadedFilesRaise];
    updatedFiles.splice(index, 1);
    setUploadedFilesRaise(updatedFiles);
  };

  const handleChangeCompany = (selected) => {
    setselectedCompany(selected);
    setOrgIdFromProject(null);
    if (selected?.companyId) {
      setCompanyName(JSON.stringify(selected.companyId));
    } else {
      setCompanyName("");
    }
    setQuery("");
  };

  useEffect(() => {
    if (query.trim() === "") {
      setUsers([]);
      return;
    }
    fetchUsers(query);
  }, [query, selectedCompany, orgIdFromProject]);

  const fetchUsers = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm.trim()) return;
      const orgIdToUse = orgIdFromProject || selectedCompany?.value;
      if (!orgIdToUse) return;
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_FILE_UPLOAD}core/users/all`,
          {
            organization_id: orgIdToUse,
            search: searchTerm,
          }
        );
        setUsers(response.data.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }, 1000),
    [selectedCompany, orgIdFromProject]
  );

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setQuery(`${user.fname} ${user.lname}  ${user.email}`);
    setUsers([]);
  };

  const resetPartialFields = () => {
    setSubject("");
    setDescription("");
    setUploadedFilesRaise([]);
    setRaiseAnotherTicket(false);
    // setTicketNumber(null); // Reset ticket number for next ticket
  };

  const resetValue = () => {
    setTicketTypeRaise("");
    setSelectedRaiseLocation("");
    setSelectedRaiseFloor("");
    setSelectedCategories("");
    setSelectedSubCategories("");
    setSubject("");
    setDescription("");
    setIsBehalfClient(false);
    setselectedCompany([]);
    setSelectedUser(null);
    setUploadedFilesRaise([]);
    setQuery("");
    setUsers([]);
    setShowBehalfClientSection(false);
    setRaiseAnotherTicket(false);
    setTicketNumber(null); // Reset ticket number when resetting form
    setPreviousTicketNumber(null); // Reset previous ticket number
  };

  const handleSubmitRaiseTicket = async (
    commentFile,
    subject,
    description,
    locationCode,
    category,
    subCategory,
    ticketType,
    floorCode,
    companyId,
    companyName,
    channel,
    channelInfo,
    userInfo,
    agentInfo,
    formInfo
  ) => {
    try {
      const response = await submitRaiseTicket(
        commentFile,
        subject,
        description,
        locationCode,
        category,
        subCategory,
        ticketType,
        floorCode,
        isBehalfClient ? companyId : "202",
        isBehalfClient ? companyName : "Smartworks Coworking Spaces Limited",
        channel,
        channelInfo,
        userInfo,
        isBehalfClient ? agentInfo : {},
        formInfo
      );
      if (response.statusValue === 200) {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        setCurrentPage(1);
        setActiveTab("open");
        setRaiseticketStatud(true);
        setTicketNumber(response.data?.ticketNumber || "Unknown"); // Store ticket number from API
        setPreviousTicketNumber(ticketNumber);
        toast.success(response?.message);
        if (isTicketUser && !raiseAnotherTicket) {
          window.location.reload();
        }
        return response;
      } else {
        showToast(response.message);
      }
    } catch (error) {
      console.log(error, "error");
      showToast("Error fetching raising ticket");
    } finally {
      setLoading(false);
    }
  };

  const uploadFile = async (file) => {
    const formData = {
      bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
      key: `attachment/${Date.now()}-${file.name}`,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
        formData
      );
      if (!response.data?.uploadUrl || !response.data?.key) {
        throw new Error("Upload URL not received");
      }
      const uploadUrl = response.data.uploadUrl;
      const binaryData = await file.arrayBuffer();
      const uploadResponse = await axios.put(uploadUrl, binaryData, {
        headers: {
          "Content-Type": file.type || "binary/octet-stream",
          "Content-Length": binaryData.byteLength,
        },
      });
      if (uploadResponse.status === 200) {
        const fileUrl = `${process.env.REACT_APP_AWS_BUCKET_PATH}${response.data.key}`;
        return fileUrl;
      } else {
        throw new Error("Upload failed");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      showToast(
        `Error uploading file: ${
          error?.response?.data?.message || error.message
        }`
      );
      throw error;
    }
  };

  const handleSubmit = async () => {
    if (loading) return;
    setLoading(true);
    let ticketTypeValue = ticketTypeRaise;
    if (ticketTypeRaise === "snag") {
      ticketTypeValue = isBehalfClient ? "snag" : "snag-internal";
    } else if (ticketTypeRaise === "support") {
      ticketTypeValue = isBehalfClient ? "support" : "internal";
    }
    let uploadedFileUrls = [];
    if (uploadedFilesRaise.length > 0) {
      const uploadPromises = uploadedFilesRaise.map((file) => uploadFile(file));
      uploadedFileUrls = await Promise.all(uploadPromises);
    }
    const userData = {
      userId: isBehalfClient
        ? JSON.stringify(selectedUser?.old_db_id)
        : JSON.stringify(userDetails?.old_db_id),
      name: isBehalfClient
        ? `${selectedUser?.fname || ""} ${selectedUser?.lname || ""}`.trim()
        : `${userDetails?.fname || ""} ${userDetails?.lname || ""}`.trim(),
      email: isBehalfClient ? selectedUser?.email : userDetails?.email,
      phone: isBehalfClient ? selectedUser?.phone : userDetails?.phone,
      role: "b-dev",
    };
    const selectedProjectObj = raiseTProjects?.find(
      (proj) => proj.value === selectedProject
    );
    let floorName = "";
    if (
      ["snag", "site-report"].includes(ticketTypeRaise) &&
      selectedProjectObj?.floor?.name
    ) {
      floorName = selectedProjectObj.floor.name;
    } else {
      const selectedFloorObj = floorForRT.find(
        (floor) => floor.value === selectedRaiseFloor
      );
      floorName = selectedFloorObj?.label || "";
    }
    const formInfo = selectedProjectObj
      ? {
          projectId: selectedProjectObj.projectId,
          projectName: selectedProjectObj.name,
          projectCompanyName: selectedProjectObj.client?.clientName || "",
        }
      : undefined;
    const finalCompanyId =
      companyName || JSON.stringify(selectedCompany?.companyId || "");
    await handleSubmitRaiseTicket(
      uploadedFileUrls,
      subject,
      description,
      selectedRaiseLocationCode,
      selectedCategories.value,
      selectedSubCategories.value,
      ticketTypeValue,
      floorName,
      finalCompanyId,
      company?.find((item) => item.value === selectedCompany?.value)?.label,
      "Ticket_web",
      {
        swDeviceName: "unknown",
        sw_device_version: "na",
        sw_app_version: "na",
        sw_spintly_version: "na",
      },
      userData,
      {
        userId: JSON.stringify(userDetails?.old_db_id),
        name: `${userDetails?.fname || ""} ${userDetails?.lname || ""}`.trim(),
        email: userDetails?.email,
        phone: userDetails?.phone,
        role: "b-dev",
      },
      formInfo
    );
    if (raiseAnotherTicket) {
      resetPartialFields();
    } else {
      resetValue();
      handleCloseModal();
    }
  };

  const handleRaiseAnotherTicketChange = (e) => {
    setRaiseAnotherTicket(e.target.checked);
  };

  const isSubmitDisabled = () => {
    if (
      !ticketTypeRaise ||
      !selectedRaiseLocation ||
      !selectedRaiseFloor ||
      !selectedCategories ||
      !selectedSubCategories ||
      !subject
    ) {
      return true;
    }
    if (isBehalfClient && (!selectedCompany || !selectedUser)) {
      return true;
    }
    return false;
  };

  const trimFileName = (name) => {
    const maxLength = 30;
    const extension = name.split(".").pop();
    const nameWithoutExt = name.slice(0, -(extension.length + 1));
    return nameWithoutExt.length > maxLength
      ? `${nameWithoutExt.slice(0, maxLength)}... .${extension}`
      : name;
  };

  const handleCopyUrl = () => {
    const url = new URL(`/ticket-lists`, window.location.origin);
    url.searchParams.set(
      "ticketNumber",
      raiseAnotherTicket ? previousTicketNumber : ticketNumber
    );
    window.open(url.toString(), "_blank");
  };

  return (
    <Fragment>
      <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-dark color1 HeaderNavBar">
        <div className="container-fluid">
          <div className="SWLogo">
            <img src={SWLogo} alt="Smartworks" />
          </div>
          {window.location.pathname === "/ticket-lists" ? (
            <div className="col-md-8">
              <div className="HeaderSearch">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  onKeyDown={handleSearchInputKeyDown}
                />
                <img src={SearchIcon} className="SearchIcon" />
                {searchQuery && (
                  <img
                    src={SearchCancelIcon}
                    alt=""
                    className="SearchCancelIcon"
                    onClick={handleClearSearch}
                  />
                )}
                <div className="SearchResultContainer d-none">
                  Search Result Container
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="HeaderRightSide col">
            <div className="HeaderRightSide_Container">
              {window.location.pathname === "/ticket-lists" ||
              window.location.pathname === "/insights" ? (
                <div className="RaiseTicket" onClick={handleOpenModal}>
                  <span className="PlusIcon">+</span>
                  <span>Raise a ticket</span>
                </div>
              ) : (
                ""
              )}
              <div className="Menu_Dots ">
                {/* <Dropdown className="MenuDotsDD">
                  <Dropdown.Toggle variant="">
                    <img src={MenuDots} alt="" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={handleLogOut}>Logout</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
                <Dropdown className="MenuDotsDD MenuDotsDD_V2">
                  <Dropdown.Toggle variant="">
                    <img src={MenuDots} alt="" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="DotsDD_V2">
                    <div className="DotsDD_V2_Heading">My Account</div>
                    <div className="DD-items_container">
                      <div className="DD-item">
                        <div className="ddLabel">Name</div>
                        <div className="ddLabel-value">
                          {localStorage.getItem("name")}
                        </div>
                      </div>
                      <div className="DD-item">
                        <div className="ddLabel">Email</div>
                        <div className="ddLabel-value">
                        {localStorage.getItem("email")}
                        </div>
                      </div>
                      <div className="DD-item">
                        <a
                          className="logoutBTN"
                          role="button"
                          onClick={handleLogOut}
                        >
                          Logout
                        </a>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <Modal
        size="lg"
        dialogClassName="modal-90w RaiseTickerModal"
        show={showModal}
        onHide={handleCloseModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            <span>*</span> Please fill following information
          </Modal.Title>
          <a
            type="button"
            className="RaiseTickerModal_Close btn-close"
            aria-label="Close"
            onClick={handleCloseModal}
          >
            &nbsp;
          </a>
        </Modal.Header>
        <Modal.Body>
          <div className="RaiseTickerModalBody">
            <div className="RaiseTicketModalContent pb-5">
              <div className="">
                <div className="FormRowRaiseTicket">
                  <label>
                    Ticket Type<span className="text-danger">*</span>
                  </label>
                  <SwSingleSelect
                    options={dataRaiseTT}
                    selectedValue={
                      dataRaiseTT?.find(
                        (option) => option.value === ticketTypeRaise
                      ) || null
                    }
                    onChange={handleTicketTypeRaiseChange}
                    placeholder="Select Ticket Type"
                  />
                </div>
                <div className="AddUserRow">
                  <label>
                    Location<span className="text-danger">*</span>
                  </label>
                  <SwSingleSelect
                    options={raiseTLocation}
                    key={selectedRaiseLocation} 
                    selectedValue={
                      raiseTLocation?.find(
                        (loc) => loc.value === selectedRaiseLocation
                      ) || null
                    }
                    onChange={handleChangeRaiseLocation}
                    placeholder="Select Location"
                  />
                </div>
                {(ticketTypeRaise === "snag" ||
                  ticketTypeRaise === "site-report") && (
                  <div className="AddUserRow">
                    <label>
                      Project<span className="text-danger">*</span>
                    </label>
                    <SwSingleSelect
                      options={raiseTProjects}
                      selectedValue={
                        raiseTProjects.find(
                          (proj) => proj.value === selectedProject
                        ) || null
                      }
                      onChange={handleChangeProject}
                      placeholder="Select Project"
                    />
                  </div>
                )}
                <div className="FormRowRaiseTicket">
                  <label>
                    Floor<span className="text-danger">*</span>
                  </label>
                  {/* <SwSingleSelect
                    options={floorForRT}
                    selectedValue={
                      floorForRT?.find(
                        (floor) => floor.value === selectedRaiseFloor
                      ) || null
                    }
                    onChange={handleChangeRaiseFloor}
                    placeholder="Select Floor"
                  /> */}
                  <SwSingleSelect
                      options={
                        floorForRT
                          ? floorForRT
                              .filter(
                                (floor, index, self) =>
                                  self.findIndex((f) => f.label === floor.label) === index
                              )
                              .sort((a, b) => {
                                // Extract number from label, fallback to 0 if not found
                                const getNum = (label) => {
                                  const match = label.match(/\d+/);
                                  return match ? parseInt(match[0], 10) : 0;
                                };
                                return getNum(a.label) - getNum(b.label);
                              })
                          : []
                      }
                    selectedValue={
                      floorForRT?.find(
                        (floor) => floor.value === selectedRaiseFloor
                      ) || null
                    }
                    onChange={handleChangeRaiseFloor}
                    placeholder="Select Floor"
                  />
                </div>
                <div className="FormRowRaiseTicket">
                  <label>
                    Category<span className="text-danger">*</span>
                  </label>
                  <SwSingleSelect
                    options={categoryOptions}
                    selectedValue={
                      categoryOptions?.find(
                        (cat) => cat.value === selectedCategories?.value
                      ) || null
                    }
                    onChange={(selected) => setSelectedCategories(selected)}
                    placeholder="Select Category"
                  />
                </div>
                <div className="FormRowRaiseTicket">
                  <label>
                    Sub-category<span className="text-danger">*</span>
                  </label>
                  <SwSingleSelect
                    options={filteredSubCategoryOptions}
                    selectedValue={
                      filteredSubCategoryOptions?.find(
                        (sub) => sub.value === selectedSubCategories?.value
                      ) || null
                    }
                    onChange={(selected) => setSelectedSubCategories(selected)}
                    placeholder="Select Sub-category"
                    isDisabled={!selectedCategories}
                  />
                </div>
                {showBehalfClientSection && (
                  <div className="FormRowRaiseTicket form-check_no form-switch_no">
                    <Form.Check
                      type="switch"
                      id="urgentTicketToggle"
                      label="Raise for Client"
                      checked={isBehalfClient}
                      onChange={handleBehalfOfClient}
                    />
                  </div>
                )}
                {isBehalfClient && (
                  <>
                    <div className="FormRowRaiseTicket">
                      <label>
                        Company<span className="text-danger">*</span>
                      </label>
                      <SwSingleSelect
                        options={company}
                        selectedValue={selectedCompany || null}
                        onChange={handleChangeCompany}
                        placeholder="Select Company"
                        isDisabled={
                          ticketTypeRaise === "snag" ||
                          ticketTypeRaise === "site-report"
                        }
                        className={
                          ticketTypeRaise === "snag" ||
                          ticketTypeRaise === "site-report"
                            ? "readonly-select"
                            : ""
                        }
                      />
                    </div>
                    <div style={{ position: "relative" }}>
                      <div className="FormRowRaiseTicket">
                        <label>
                          User<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          value={query}
                          onChange={(e) => {
                            setQuery(e.target.value);
                            if (e.target.value === "") {
                              setSelectedUser(null);
                            }
                          }}
                          placeholder="Search user..."
                          className="form-control lightFeildText"
                          disabled={selectedCompany?.length === 0}
                        />
                        {users.length > 0 && (
                          <ul className="InputSuggestion">
                            {users.map((user) => (
                              <li
                                key={user.id}
                                onClick={() => handleSelectUser(user)}
                              >
                                {user.fname} {user.lname} ({user.email})
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </>
                )}
                <div className="FormRowRaiseTicket">
                  <label>
                    Subject<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control lightFeildText"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </div>
                <div className="FormRowRaiseTicket">
                  <label>Description</label>
                  <textarea
                    className="form-control lightFeildTextArea"
                    value={description}
                    rows={4}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <div className="FormRowRaiseTicket">
                  <Form.Check
                    type="checkbox"
                    id="checkboxRaiseAnotherTicket"
                    name="checkboxRaiseAnotherTicket"
                    label="Raise another ticket"
                    inline
                    checked={raiseAnotherTicket}
                    onChange={handleRaiseAnotherTicketChange}
                  />
                </div>
                <div className="AddNoteToTicket">
                  <div
                    className="AtachedFileShow"
                    style={{ minHeight: "auto" }}
                  >
                    {uploadedFilesRaise.map((file, index) => (
                      <div className="AtachedFileBox" key={index}>
                        {getMimeType(file.name) === "application/pdf" ? (
                          <>
                            <img
                              src={PdfFileIcon}
                              alt="PDF Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "video/webm" ? (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "application/zip" ? (
                          <>
                            <img
                              src={ZipIcon}
                              alt="Zip Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "video/mp4" ||
                          getMimeType(file.name) === "video/MP4" ? (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "video/mov" ? (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "text/csv" ? (
                          <>
                            <img
                              src={CSVIcon}
                              alt="CSV Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.ms-powerpoint" ? (
                          <>
                            <img
                              src={PowerPointIcon}
                              alt="POWER Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                          <>
                            <img
                              src={DocIcon}
                              alt="Doc Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                          <>
                            <img
                              src={XLSXIcon}
                              alt="XLSX Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : (
                          <>
                            <img
                              src={URL.createObjectURL(file)}
                              alt={`uploaded-file-${index}`}
                              style={{
                                objectFit: "cover",
                                width: "60px",
                                height: "60px",
                              }}
                            />
                          </>
                        )}
                        <div className="AtachedFileBox_Overlay">
                          <img
                            src={AttachementRemoveIcon}
                            alt=""
                            onClick={() => handleRemoveImage(index)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {console.log(ticketNumber, raiseAnotherTicket, "dhgsfhjgh")}
          {(ticketNumber !== null && !raiseAnotherTicket) ||
          (previousTicketNumber !== null && raiseAnotherTicket) ? (
            <div className="TicketCreatedBar">
              Ticket #{raiseAnotherTicket ? previousTicketNumber : ticketNumber}{" "}
              has been created.{" "}
              <a href="#" onClick={handleCopyUrl}>
                View ticket
              </a>
            </div>
          ) : (
            ""
          )}
          {/* )} */}
          <div className="RaiseTicketModalFoot">
            <div className="RaiseTicketModalFoot_content">
              <div className="ModalToolCTA d-flex">
                <a
                  className="ModalToolCTA_AttacheFile"
                  role="button"
                  onClick={handleIconClickReopen}
                >
                  <img src={AddingAttachementIcon} alt="" />
                </a>
                <input
                  type="file"
                  ref={fileInputRef3}
                  style={{ display: "none" }}
                  onChange={handleFileRaiseChange}
                  multiple
                />
                <div className="ms-2">Attach relevant files</div>
              </div>
              <div className="ModalCTA">
                <button
                  className="btn btn-dark ModalCTA_Dark"
                  onClick={handleSubmit}
                  disabled={loading || isSubmitDisabled()}
                >
                  {loading ? (
                    <>
                      <i className="fa fa-refresh fa-spin"></i> Processing
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showThankYou} onHide={() => setShowThankYou(false)} centered>
        <Modal.Body className="text-center">
          <h4>Thank You!</h4>
          <p>Your ticket has been submitted successfully.</p>
          <Button variant="dark" onClick={() => setShowThankYou(false)}>
            Close
          </Button>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default Header;
